module.exports = __webpack_public_path__ + "static/media/shield.23b19192.png";